import { render, staticRenderFns } from "./ChatterComposer.vue?vue&type=template&id=3e3e3b0b&scoped=true"
import script from "./ChatterComposer.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatterComposer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatterComposer.vue?vue&type=style&index=0&id=3e3e3b0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3e3b0b",
  null
  
)

export default component.exports